const defaultDateOptions = {
  year: 'numeric',
  // Numeric representation of the year
  month: 'short',
  // Abbreviated month name
  day: '2-digit' // Two-digit representation of the day

};
const defaultTimeOptions = {
  hour: '2-digit',
  // Two-digit representation of the hour
  minute: '2-digit',
  // Two-digit representation of the minute
  hourCycle: 'h23'
};

function format({
  cultureCode,
  date,
  options
}) {
  if (!date) {
    return 'Invalid date';
  }

  return new Intl.DateTimeFormat(cultureCode, options).format(date);
}

export function formatDate({
  cultureCode,
  date,
  options
}) {
  const formatOptions = { ...defaultDateOptions,
    ...options
  };
  return format({
    cultureCode,
    date,
    options: formatOptions
  });
}
export function formatTime({
  cultureCode,
  date,
  options
}) {
  const formatOptions = { ...defaultTimeOptions,
    ...options
  };
  return format({
    cultureCode,
    date,
    options: formatOptions
  });
}
export function formatDateTime({
  cultureCode,
  date,
  options
}) {
  const formatOptions = { ...defaultDateOptions,
    ...defaultTimeOptions,
    ...options
  };
  return format({
    cultureCode,
    date,
    options: formatOptions
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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